<template>
  <div id="risk-persons">    
    <vs-popup fullscreen :title="process.title" :active.sync="popupActive">      
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-list>
            <vs-list-item :title="item" v-for="(item,index) in process.actionsList" :key="index" @click.native="getRequirements(item)">              
              <vs-chip color="success">Show</vs-chip>
            </vs-list-item>
          </vs-list>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" v-for="item in courses" :key="item.course">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-list v-for="(obj,index) in item.courses" :key="index">
              <vs-list-header :title="item.headline"></vs-list-header>
              <vs-list-item :title="'Level: '+ item.level_id"></vs-list-item>
              <vs-list-item :title="'Course Id: '+ obj.course_id"></vs-list-item>
              <vs-list-item :title="obj1" v-for="(obj1,index1) in obj.reqs" :key="index1"  @click.native="getReqBreakDown(obj1)">
                <vs-chip color="success">Show</vs-chip>                
              </vs-list-item>              
            </vs-list>            
          </vs-col>
      </vs-row>
      <vs-card style="position: absolute; right:50px;top:50px; width:400px;" :title="innerPopUp.title" v-if="innerPopUp.details.length>0 && innerPopUp.active">
          <vs-list v-for="(obc,indexx) in innerPopUp.details" :key="indexx">
            <vs-list-item :title="'Desc: '+ obc.desc"></vs-list-item>
            <vs-list-item :title="'Req: '+ obc.req"></vs-list-item>
          </vs-list>
      </vs-card>
    </vs-popup>
    <vs-row vs-align="center" vs-type="flex" vs-justify="space-around" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">        
        <vs-card class="cardx" fixedHeight>
          <div slot="header">
            <h2 class="text-center">Client type:</h2>
            <h3 class="text-center">Natural Persons</h3>
          </div>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="3" v-for="(item,index) in cards" :key="index">
              <vs-card class="cardx" fixedHeight>
                <div>
                  <vs-list>
                    <vs-list-item :title="item.title" :subtitle="item.limit_desc[0]"></vs-list-item>
                    <vs-list v-for="(obj,index2) in item.occurrences" :key="index2">
                      <vs-list-header :title="obj.tran_group"></vs-list-header>
                      <vs-list-item  v-for="(obj1,index3) in obj.tran_type" :key="index3" :title="obj1" @click.native="getProcess(item.title,obj.tran_group,obj1)">
                        <vs-chip color="success">Show</vs-chip>
                      </vs-list-item>
                    </vs-list>
                  </vs-list>                  
                </div>              
              </vs-card>
            </vs-col>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">        
        <vs-card class="cardx" fixedHeight>
          <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
            <vs-card class="cardx" fixedHeight>
              <div class="text-center">
                <vs-list>
                  <vs-list-header title="Bank limits"></vs-list-header>
                  <vs-list-item  v-for="(item1,index3) in extra" :key="index3" :title="item1.account"></vs-list-item>
                </vs-list>
              </div>              
            </vs-card>
          </vs-col>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import axios from "@/axios.js"
import VxCard from '../../../components/vx-card/VxCard.vue';
import vSelect from 'vue-select';
export default {
  components: { VxCard, vSelect },

  data() {
    
    let data = {
      cards:[],
      extra:[],
      popupActive: false,
      process: {title:null,actionsList:[]},
      queryParams: null,
      courses:[],
      innerPopUp:{
        active:false,
        details:[]
      }
    }    
    return data;
  },
  methods:{    
    setData: function(){
        let that = this;
        this.$vs.loading();
        axios.get("/api/risk-persons")
          .then((response) => {
            that.cards.splice(0);
            that.extra.splice(0);
            const data = response.data.details;
            for(let i in data){
              const obj = JSON.parse(data[i].object);
              that.cards.push(obj);
            }
            const last = response.data.last;
            for(let i in last){
              const obj = JSON.parse(last[i].object);
              that.extra.push(obj);
            }
            that.$vs.loading.close() 
          })
          .catch(() => { })
    },
    getProcess: function(type,riskGroup,tranGroup){
      let that = this;
      that.innerPopUp.details.splice(0);
      that.innerPopUp.active = false;
      this.$vs.loading();
      const params = {
        type:type,
        riskGroup:riskGroup,
        tranGroup:tranGroup
      };
      this.queryParams = params;
      let obj = Object.keys(params).map((key) => [key, params[key]].join('=')).join('&');
      axios.get("/api/process"+'?'+obj)
      .then((response) => {
        that.courses.splice(0);
        const data = response.data;        
        for(let i in data){
          const obj = JSON.parse(data[i].object);
          that.process.title = obj.headline;
          that.process.actionsList = obj.processes;
        }            
        that.popupActive = true;
        that.$vs.loading.close() 
      })
      .catch(() => { that.$vs.loading.close() })
    },
    getReqBreakDown: function(breakdown){
      let that = this;
      this.$vs.loading();
      this.queryParams.breakdown = breakdown;
      let obj = Object.keys(this.queryParams).map((key) => [key, this.queryParams[key]].join('=')).join('&')
      axios.get("/api/req-breakdown"+'?'+obj)
      .then((response) => {
        const data = JSON.parse(response.data[0].object).reqs;
        that.innerPopUp.details.splice(0);
        that.innerPopUp.title = data.req_headline;
        for(let i in data.break_req){
          that.innerPopUp.details.push(data.break_req[i]);
        }
        that.innerPopUp.active = true;                
        that.$vs.loading.close()
      })
      .catch(() => { that.$vs.loading.close() })
    },
    getRequirements: function(requirements){
      let that = this;
      this.$vs.loading();
      that.innerPopUp.details.splice(0);
      that.innerPopUp.active = false;
      this.queryParams.requirements = requirements;
      let obj = Object.keys(this.queryParams).map((key) => [key, this.queryParams[key]].join('=')).join('&')
      axios.get("/api/process-requirements"+'?'+obj)
      .then((response) => {
        that.courses.splice(0);
        const data = response.data;        
        for(let i in data){
          const obj = JSON.parse(data[i].object);
          that.courses.push(obj);
        }         
        that.popupActive = true;
        that.$vs.loading.close()
      })
      .catch(() => { that.$vs.loading.close() })
    }
  },
  computed: {    
  },
  mounted() {    
  },
  created(){
    this.setData();
  }
}

</script>
<style scoped>
/*:-moz-any().cardx{
  margin: 15px;
}*/
</style>